import React, { useEffect } from "react";

// Importing Packages
import { v4 as uuidv4 } from "uuid";

//Importing Libraries
var Highcharts = require("highcharts");

function StackedCharts(props) {
  let id = generateRandomGuid();
  function generateRandomGuid() {
    return uuidv4();
  }

  useEffect(() => {
    function renderChart(id,label,linecolor) {
      Highcharts.chart(`sc-${id}`, {
        chart: {
          type: "area",
          plotBackgroundColor: null,
          plotBorderWidth: null,
          backgroundColor: null,
          plotShadow: false,
          height: 250,
        },
        title: {
          text: "",
        },

        credits: {
          enabled: false,
        },

        exporting: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },

        xAxis: {
          categories: props.data.xAxisCategories,

          labels: {
            staggerLines: 1,
            style: {
              /* fontFamily: 'Roboto', */
              fontWeight: "bold",
              color: label,
            },
          },
        },
        yAxis: {
          title: {
            text: "",
            labels: {
              enabled: false,
            },
          },

          labels: {
            enabled: false,
          },
          gridLineWidth: 0,
          minorGridLineWidth: 0,
        },

        tooltip: {
          useHTML: true,
          shared: false,
          headerFormat:
            '<span style="font-size:12px"><b>{point.key}</b></span><br>',

          style: {
            color: "#fff",
          },
          valueDecimals: 0,
          backgroundColor: "#E9631C",
          borderColor: "transparent",
          borderRadius: 10,
          borderWidth: 3,
        },
        plotOptions: {
          series: {
            /*  pointStart: 2012 */
            marker: {
              enabled: true,
            },
          },
          area: {
            stacking: "normal",
            lineColor: "transparent",
            lineWidth: 0,
            marker: {
              lineWidth: 0,
              lineColor: "transparent",
              fillColor: "#E9631C",
            },
          },
        },
        series: [
          {
            data: props.data.data[0],

            color: {
              linearGradient: [0, 0, 0, 300],
              stops: [
                [0, props.colorset.firstSet[0]],
                [2, props.colorset.firstSet[1]],
              ],
            },

            marker: {
              lineWidth: 2,
              lineColor: linecolor,
              fillColor: "#E9631C",
              borderWidth: 3,
              borderColor: "red",
            },
          },
          {
            data: props.data.data[1],
            color: {
              linearGradient: [0, 0, 0, 350],
              stops: [
                [0, props.colorset.secondSet[0]],
                [1, props.colorset.secondSet[1]],
              ],
            },

            marker: {
              lineWidth: 2,
              lineColor: linecolor,
              fillColor: "#239D9C",
              symbol: "circle",
            },
          },
        ],
      });
    }
    renderChart(id,props.label,props.linecolor);
  }, [id,props,props.label,props.linecolor]);

  return <div id={`sc-${id}`}></div>;
}

export default StackedCharts;
